import adresse from './api/compte/adresse';
import connexion from './api/compte/connexion';
import cookie from './api/jel/cookie';
import depot from './api/compte/depot';
import identite from './api/compte/identite';
import profession from './api/compte/profession';
import profile from './api/compte/profile';
import session from './api/compte/session';

const taches = {
  ...adresse,
  ...connexion,
  ...cookie,
  ...depot,
  ...identite,
  ...profession,
  ...profile,
  ...session,
};

export default { taches };
